export default __webpack_public_path__ + "static/media/logo.dcc72426.svg";